import { splitTaxonomy } from "./RuleUtil";

export const getModuleNameFromTaxonomy = (taxonomy: string) => {
  const splitName = splitTaxonomy(taxonomy);
  if (!splitName) {
    return taxonomy;
  } else if (splitName?.header.includes("#")) {
    return splitName.header.split("#")[1];
  } else {
    return splitName.header;
  }
};

export const taxonomyMatchesModule = (taxonomy: string | null | undefined, moduleName: string): boolean => {
  if (!taxonomy) return false;
  const part = taxonomy.split(";")[0];
  return part.includes("#") ? part.split("#")[1] === moduleName : part === moduleName;
};

export const getTaxonomyContentSection = (taxonomy: string | null | undefined): string => {
  if (!taxonomy) return "";
  return taxonomy.split(";")[1]?.trim() ?? "";
};

export const getContentNameFromTaxonomy = (
  taxonomy: string | undefined,
  contentDisplayName: string
) => {
  if (taxonomy?.includes(";")) {
    return `${taxonomy.split(";")[1].trim()} > ${contentDisplayName}`;
  }
  return contentDisplayName;
};
